import React from 'react';
import CardProject from '../../components/CardProject';

interface Props {
  title: string;
  projects: any[];
}

export const Projects = ({title, projects}: Props) => {
  return (
    <div id="Projects" className="w-full h-full bg-gray-50">
      <h2 className="text-2xl text-gray-800 font-bold md:text-4xl text-center pt-20 px-5">
        {title}
      </h2>
      <div className="flex justify-center items-center">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-4 lg:gap-16 px-7 py-8 lg:px-8">
          {projects.map(project => {
            return (
              <CardProject
                key={project.title}
                image={project.image}
                title={project.title}
                description={project.description}
                technologies={project.technologies}
                code={project.code}
                demo={project.demo}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Projects;
